/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RefLanguageDto } from '../../models/ref-language-dto';

export interface ReferentialGetLanguages$Plain$Params {
}

export function referentialGetLanguages$Plain(http: HttpClient, rootUrl: string, params?: ReferentialGetLanguages$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RefLanguageDto>>> {
  const rb = new RequestBuilder(rootUrl, referentialGetLanguages$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RefLanguageDto>>;
    })
  );
}

referentialGetLanguages$Plain.PATH = '/v1/Referential/GetLanguages';
